import pagination from "../static/pagination";

const moduleName = "waStatusModule";

const state = {
    isFetching: false,
    isLoadMore: false,
    isFilter: false,
    response: {},
    deviceid: null,

    listPerangkat: [],
    dataDeviceTiny: {},
    storyIndex: {},
    statusTiny: {},
    statusFull: {},
    fileUpload: null,
    preview: {},

    storyAktif: [],
    storyAktifTotal: 0,
    showStoryAktif: [],
    endStoryAktif: {},
    storyAktifPage: pagination(),

    aktivitas: [],
    aktivitasTotal: 0,
    aktivitasShow: [],
    aktivitasEnd: {},
    aktivitasPage: pagination(),

    storyRiwayat: [],
    storyRiwayatTotal: 0,
    showStoryRiwayat: [],
    endStoryRiwayat: {},
    storyRiwayatPage: pagination(),
};
export { state as default, moduleName };
